export const partnersSkeleton = () => {
    return [
        {
            row: [15, 15, 70],
            items: ['title', 'title', 'empty'],
            gap: 2
        },
        {
            row: [16.6, 16.6, 16.6, 16.6, 16.6, 16.6],
            items: ['image', 'image', 'image', 'image', 'image', 'image'],
            gap: 2
        }
    ];
};
